import { render, staticRenderFns } from "./csvViewer.vue?vue&type=template&id=2afa11f9&scoped=true&"
import script from "./csvViewer.vue?vue&type=script&lang=js&"
export * from "./csvViewer.vue?vue&type=script&lang=js&"
import style0 from "./csvViewer.vue?vue&type=style&index=0&id=2afa11f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa11f9",
  null
  
)

export default component.exports